exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jump-nav-edit-form[data-v-530af7dc]  .el-form-item__label{white-space:nowrap;line-height:32px}.dual-cate-help-tips[data-v-530af7dc]{color:#ff9e3e;line-height:20px;margin:-8px 0 12px 132px}", ""]);

// exports
